// extracted by mini-css-extract-plugin
export default {"host":"TreeNavSwitch_host__Slgq5"};